<template>
  <iSelectPlan />
</template>

<script setup lang="ts">
import iSelectPlan from "@/views/coaching/sections/SelectPlan.vue"
</script>
